const errorHelper = {
  required: 'Это поле обязятельно',
  phone: 'Формат номера телефона +375-XX-XXX-XX-XX',
  common: 'Не удалось выполнить запрос. Повторите попытку позже.',
};

export default errorHelper;
